module.exports = __webpack_public_path__ + "img/proyecto_11_mv.7b1643ae.png";